
export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  // {
  //   field: 'col-opt',
  //   title: that.$l('INDEX.table_label_operation') || '操作',
  //   headerAlign: 'center',
  //   align: 'center',
  //   fixed: 'right',
  //   width: 90,
  //   slots: { default: 'opt' },
  // },
  {
    title: that.$l('table_label_date') || '日期',
    field: 'v_createTime',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_factoryOrderNo') || '工厂订单编号',
    field: 'factoryOrderNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_masterNcNo') || '成品编码',
    field: 'masterNcNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_ncNo') || '子件编码',
    field: 'ncNo',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_goodsName') || '产品名称',
    field: 'goodsName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_passQty') || '良品数量',
    field: 'passQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_notPassQty') || '不良品数量',
    field: 'notPassQty',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_yieldRate') || '良品率',
    field: 'yieldRate',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'yieldRate' },
  },
  {
    title: that.$l('table_label_cropping') || '裁剪问题',
    field: 'cropping',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sewing') || '缝制问题',
    field: 'sewing',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_material') || '物料问题',
    field: 'material',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_other') || '其它问题',
    field: 'other',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
]
